import Container from "components/general/Container";
import PageHeader from "components/general/Headers/PageHeader";
import ScrollContainer from "components/general/ScrollContainer";
import Seo from "components/general/Seo";
import { NotificationPage } from "components/notification/NotificationPage";
import React from "react";

export default function Page() {
	return (
		<ScrollContainer>
			<Seo title="Notifications | Abconet" description="" />
			<Container>
				<PageHeader title="Notifications" />
				<NotificationPage />
			</Container>
		</ScrollContainer>
	);
}
